var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.0496C13.3866 11.0496 13.7 10.7362 13.7 10.3496C13.7 9.96301 13.3866 9.64961 13 9.64961L13 11.0496ZM2.50503 9.85463C2.23166 10.128 2.23166 10.5712 2.50503 10.8446L6.9598 15.2994C7.23316 15.5727 7.67638 15.5727 7.94975 15.2994C8.22311 15.026 8.22311 14.5828 7.94975 14.3094L3.98995 10.3496L7.94975 6.38981C8.22312 6.11644 8.22312 5.67323 7.94975 5.39986C7.67638 5.12649 7.23317 5.12649 6.9598 5.39986L2.50503 9.85463ZM13 9.64961L3 9.64961L3 11.0496L13 11.0496L13 9.64961Z",
    fill: "#AD1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.84961V5.84961C10 4.4689 11.1193 3.34961 12.5 3.34961H14.5C15.8807 3.34961 17 4.4689 17 5.84961V14.8496C17 16.2303 15.8807 17.3496 14.5 17.3496H12.5C11.1193 17.3496 10 16.2303 10 14.8496V14.3496",
    stroke: "#AD1F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8e1c3017ba726f31be5967e3c89c9b30.svg";
export { ForwardRef as ReactComponent };